import { useContext } from "react";
import { SettingsContext } from "~/contexts/settingsContext";

/**
 * Hook to access settings state and controls
 */
export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
};
